import { getCurrentLocaleCode } from "./get-gtm-client";

export const getRenderedLocale = (): string | undefined =>
  (typeof document !== "undefined" && getCurrentLocaleCode()) || undefined;
